module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-bar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    style: ({
      'z-index': _vm.showResults ? 35 : 10,
      'width': _vm.showResults ? 'calc(100% - 20px)' : ''
    }),
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "focus": function($event) {
        _vm.showResults = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.showResults) ? _c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.showResults = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })]) : _vm._e(), _vm._v(" "), (_vm.showResults) ? _c('div', {
    staticClass: "search-overlay",
    on: {
      "click": function($event) {
        _vm.showResults = false
      }
    }
  }, [_c('div', {
    staticClass: "search-results"
  }, [_c('ul', _vm._l((_vm.locationResult), function(location) {
    return (location !== undefined) ? _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.open(location)
        }
      }
    }, [_vm._v("\n          " + _vm._s(location.properties.name)), _c('small', [_vm._v(", " + _vm._s(location.properties.region))]), _vm._v(" "), (location.properties.source === 'paraglidingearth-beta') ? _c('small', [_c('translate', {
      attrs: {
        "translate-context": "search result"
      }
    }, [_vm._v("(Paragliding)")])], 1) : _vm._e(), _vm._v(" "), (location.properties.source === 'ffvl-beta') ? _c('small', [_c('translate', {
      attrs: {
        "translate-context": "search result"
      }
    }, [_vm._v("(Kitesurf)")])], 1) : _vm._e()]) : _vm._e()
  }))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59cda805"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search-box.vue
// module id = 336
// module chunks = 1